// extracted by mini-css-extract-plugin
export default {"hamburger":"Hamburger_hamburger__axzzU","active":"Hamburger_active__wc+v5"};